const transformConsentSourceList = ({ results = [] }) =>
  results.map(({ id, description }) => ({
    optionLabel: description,
    id,
  }));

export default transformConsentSourceList;
